import React, { useState, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPinIcon, ShieldCheckIcon, BriefcaseIcon, DollarSignIcon, WifiIcon, ChevronDownIcon, ExternalLinkIcon } from 'lucide-react';
import type { Job } from '../data/jobsFeed';
export function JobCard({
  job
}: {
  job: Job;
}) {
  const [expanded, setExpanded] = useState(false);
  const applyHref = job.applyEmail ? `mailto:${job.applyEmail}?subject=${encodeURIComponent(`Application: ${job.title}`)}` : `mailto:careers@newriversystems.com?subject=${encodeURIComponent(`Application: ${job.title}`)}`;
  return <div className="card p-0 overflow-hidden text-left" data-id="element-157" data-mp="3hc7c74y4cgx2">
      <div className="p-6" data-id="element-158" data-mp="3hanxvjw0wfxx">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-4" data-id="element-159" data-mp="3m37b2fqst927">
          <h3 className="font-heading font-bold text-lg text-nrs-navy leading-snug" data-id="element-160" data-mp="2oobhg5s40z2x">
            {job.title}
          </h3>
          <div className="flex flex-shrink-0 flex-wrap gap-2" data-id="element-161" data-mp="2tmd4t2wkjkk7">
            {job.remote && <span className="self-start inline-flex items-center gap-1 px-2.5 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded-full" data-id="element-162" data-mp="3ezfq7rwe097z">
                <WifiIcon className="h-3 w-3" data-id="element-163" data-mp="3a1ea9fu9cq0q" />
                Remote
              </span>}
            {job.jobType && <span className="self-start inline-flex items-center gap-1 px-2.5 py-1 bg-blue-100 text-nrs-blue text-xs font-semibold rounded-full" data-id="element-164" data-mp="3582xky2rlf0w">
                <BriefcaseIcon className="h-3 w-3" data-id="element-165" data-mp="2w9r48oaik34r" />
                {job.jobType}
              </span>}
          </div>
        </div>

        <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-gray-600 mb-5" data-id="element-166" data-mp="2r8jsyf95wltc">
          <span className="inline-flex items-center gap-1.5" data-id="element-167" data-mp="2mc34tl1yq7g9">
            <MapPinIcon className="h-4 w-4 text-nrs-orange" data-id="element-168" data-mp="2hc70tlt9mg0p" />
            {job.location}
          </span>
          {job.clearance && <span className="inline-flex items-center gap-1.5" data-id="element-169" data-mp="kjx5mui832iy">
              <ShieldCheckIcon className="h-4 w-4 text-nrs-orange" data-id="element-170" data-mp="fkkie8nfvtfu" />
              {job.clearance}
            </span>}
          {job.salaryRange && <span className="inline-flex items-center gap-1.5" data-id="element-171" data-mp="2a0itkjf5ocw0">
              <DollarSignIcon className="h-4 w-4 text-nrs-orange" data-id="element-172" data-mp="2erir9qw3myzk" />
              {job.salaryRange}
            </span>}
        </div>

        <button type="button" onClick={() => setExpanded(v => !v)} aria-expanded={expanded} className="inline-flex items-center gap-1.5 text-nrs-blue font-semibold text-sm hover:text-nrs-orange transition-colors" data-id="element-173" data-mp="203e8kmx1qngs">
          View Full Details
          <ChevronDownIcon className={`h-4 w-4 transition-transform ${expanded ? 'rotate-180' : ''}`} data-id="element-174" data-mp="2ss3er0cylize" />
        </button>
      </div>

      <AnimatePresence initial={false} data-id="element-175" data-mp="2jqvpt8wc1uhz">
        {expanded && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden border-t border-gray-100" data-id="element-176" data-mp="2jq2dztiioesz">
            <div className="p-6 bg-nrs-light/50 space-y-5" data-id="element-177" data-mp="1celj99axjdv5">
              {job.descriptionHtml && <div data-id="element-178" data-mp="14s7xhvet1d4c">
                  <h4 className="font-heading font-bold text-sm text-nrs-navy uppercase tracking-wider mb-2" data-id="element-179" data-mp="14rohik8psysy">
                    Description &amp; Requirements
                  </h4>
                  <div className="job-description text-gray-700 text-sm leading-relaxed" dangerouslySetInnerHTML={{
              __html: job.descriptionHtml
            }} data-id="element-180" data-mp="1er6wsndojweo" />
                </div>}

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-181" data-mp="m3t5b4sr3t1y">
                {job.clearance && <div data-id="element-182" data-mp="h4zwhpoesq84">
                    <h4 className="font-heading font-bold text-sm text-nrs-navy uppercase tracking-wider mb-1" data-id="element-183" data-mp="h5rokqiss5tn">
                      Clearance
                    </h4>
                    <p className="text-gray-700 text-sm" data-id="element-184" data-mp="r134vd9utl3i">{job.clearance}</p>
                  </div>}
                {job.salaryRange && <div data-id="element-185" data-mp="3az2184hppdk">
                    <h4 className="font-heading font-bold text-sm text-nrs-navy uppercase tracking-wider mb-1" data-id="element-186" data-mp="3afmtz685f38">
                      Salary Range
                    </h4>
                    <p className="text-gray-700 text-sm" data-id="element-187" data-mp="2xt11iy5mohdk">{job.salaryRange}</p>
                  </div>}
              </div>

              <div className="flex flex-wrap gap-3 pt-1" data-id="element-188" data-mp="31qysa5f1rbj2">
                {job.link && <a href={job.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-nrs-blue font-semibold text-sm hover:text-nrs-orange transition-colors" data-id="element-189" data-mp="36rcrqz2l1d5h">
                    View original posting
                    <ExternalLinkIcon className="h-4 w-4" data-id="element-190" data-mp="3lh0r3ur7e1qk" />
                  </a>}
                <a href={applyHref} className="inline-flex items-center gap-1.5 text-nrs-orange font-semibold text-sm hover:underline" data-id="element-191" data-mp="3lj56b8ujyn65">
                  Apply for this role →
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}